import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Truck, CalendarDays, FileText, MoreHorizontal } from 'lucide-react';
import { clsx } from 'clsx';

const BOTTOM_ITEMS = [
  { path: '/', label: 'Inicio', icon: LayoutDashboard },
  { path: '/vehicles', label: 'Vehículos', icon: Truck },
  { path: '/availability', label: 'Calendario', icon: CalendarDays },
  { path: '/documents', label: 'Docs', icon: FileText },
  { path: '/more', label: 'Más', icon: MoreHorizontal },
];

export function BottomNav() {
  const location = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 lg:hidden safe-area-bottom" aria-label="Navegación inferior">
      <div className="flex items-center justify-around h-16 px-2">
        {BOTTOM_ITEMS.map(({ path, label, icon: Icon }) => {
          const isActive = path === '/'
            ? location.pathname === '/'
            : path === '/more'
              ? ['/opportunities', '/referrals', '/gamification', '/settings', '/profile', '/more'].some(p => location.pathname.startsWith(p))
              : location.pathname.startsWith(path);

          return (
            <Link
              key={path}
              to={path === '/more' ? '/opportunities' : path}
              className={clsx(
                'flex flex-col items-center justify-center gap-0.5 px-2 py-1 rounded-lg transition-all duration-200 min-w-[56px]',
                isActive ? 'text-brand-black' : 'text-gray-400'
              )}
            >
              <Icon size={22} strokeWidth={isActive ? 2.5 : 2} />
              <span className={clsx('text-[10px]', isActive ? 'font-semibold' : 'font-medium')}>{label}</span>
              {isActive && <span className="w-1 h-1 rounded-full bg-brand-yellow" />}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
